import { QueryKey } from '@tanstack/react-query';
import apiClient from '../../../services/apiClient';
import {
  GoodsFilter,
  GoodsRequest,
  GoodsResponse,
} from '../types/goods-response';
import { TransformFilters } from '../../../utils';

export const GoodsReqAPI = {
  gets: async ({
    queryKey,
  }: {
    queryKey: QueryKey;
  }): Promise<GoodsResponse> => {
    const [, filters] = queryKey as [string, GoodsFilter?];
    const transformedFilters = TransformFilters(filters);
    const response = await apiClient.get('/api/petition/good', {
      params: {
        ...transformedFilters,
        paginate: true,
        page: filters?.page,
      },
    });
    return response.data;
  },
  get: async (id: string): Promise<GoodsRequest> => {
    const response = await apiClient.get(`/api/petition/good/${id}`);
    return response.data;
  },
  put: async (
    id: string,
    data: Record<string, GoodsRequest>
  ): Promise<void> => {
    const response = await apiClient.put(`/api/petition/good/${id}`, data);
    return response.data;
  },
  post: async (req: GoodsRequest): Promise<void> => {
    delete req.id;
    const response = await apiClient.post(
      '/api/petition/good',
      {
        ...req,
        documents: req?.documents?.map((doc) => doc?.file) || [],
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },
  delete: async (id: string): Promise<void> => {
    const response = await apiClient.delete(`/api/petition/good/${id}`);
    return response.data;
  },
  export: async (ids: string[]): Promise<void> => {
    const params = ids.map((id) => `ids[]=${id}`).join('&');
    const response = await apiClient.get(`/api/petition/good/export?${params}`, {
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'bienes_exportados.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return response.data;
  },
  downloadFiles: async (id: string): Promise<void> => {
    try {
      const response = await apiClient.get<Blob>(
        `/api/petition/good/documents/${id}`,
        {
          responseType: 'blob',
        }
      );

      const zipBlob = response as unknown as Blob;
      const url = window.URL.createObjectURL(zipBlob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `bienes_exportados.zip`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
    } catch (error: any) {
      throw error;
    }
  },
 downloadPDF: async (id: string): Promise<void> => {
    try {
      const { data } = await apiClient.get(`/api/petition/good/pdf/${id}`);
      const { url: fileUrl, filename = 'Comprobante_de_solicitud.pdf' } = data || {};

      if (!fileUrl) throw new Error('No se encontró la URL del documento.');

      const blob = await (await fetch(fileUrl)).blob();
      const downloadUrl = URL.createObjectURL(blob);

      const link = Object.assign(document.createElement('a'), {
        href: downloadUrl,
        download: filename,
      });

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      throw error;
    }
  },
  annulled: async (
    id: string,
    data: Record<string, GoodsRequest>
  ): Promise<void> => {
    const response = await apiClient.put(`/api/petition/good/annulled/${id}`, data);
    return response.data;
  },
};
